export default __webpack_public_path__ + "static/media/banner-default.aabe63cb.jpg";